// State object
const state = {
  periodTime: 'today',
  isUse: true,
  selectedDay: ''
}

// Getter functions
const getters = {
  getPeriodTime(state) {
    return state.periodTime;
  },
  getIsUse(state) {
    return state.isUse;
  },
  getSelectedDay(state) {
    return state.selectedDay
  }
}

// Mutations
const mutations = {
  setPeriodTime(state, data) {
    state.periodTime = data;
  },
  setIsUse(state, flag) {
    state.isUse = flag;
  },
  setSelectedDay(state, data) {
    state.selectedDay = data;
  }
}

// Actions
const actions = {
  blockUse({ commit }, data) {
    commit('setIsUse', data);
  },
  setMapDay({ commit }, data) {
    commit('setSelectedDay', data);
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
